import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { RootState } from '..';
import {
  CreateQuestionRequest,
  GetQuestionRequest,
  ListQuestionsRequest,
  Question,
  SearchQuestionRequest,
  UpdateQuestionRequest,
} from 'src/types/helios/Question';
import {
  updateQuestionApiThunk,
  createQuestionApiThunk,
  fetchQuestionsApiThunk,
  clearAllApiStatus,
  searchQuestionApiThunk,
  fetchQuestionByIdApiThunk,
  clearQuestionData,
  selectCurrentQuestion,
} from './questionSlice';

export const useQuestion = () => {
  const dispatch = useAppDispatch();
  const questionsList = useAppSelector(
    (state: RootState) => state.question.questionsList,
  );

  const fetchQuestionsApiStatus = useAppSelector(
    (state: RootState) => state.question.fetchQuestionsApiStatus,
  );
  const searchQuestionApiStatus = useAppSelector(
    (state: RootState) => state.question.searchQuestionApiStatus,
  );
  const createQuestionApiStatus = useAppSelector(
    (state: RootState) => state.question.createQuestionApiStatus,
  );

  const updateQuestionApiStatus = useAppSelector(
    (state: RootState) => state.question.updateQuestionApiStatus,
  );
  const getQuestionByIdApiStatus = useAppSelector(
    (state: RootState) => state.question.getQuestionByIdApiStatus,
  );

  const question = useAppSelector((state: RootState) => state.question.question);
  const currentSelectedQuestion = useAppSelector(
    (state: RootState) => state.question.currentSelectedQuestion,
  );

  const loadQuestions = useCallback(
    async (data: ListQuestionsRequest) => {
      dispatch(fetchQuestionsApiThunk(data));
    },
    [dispatch],
  );

  const createQuestion = useCallback(
    async (data: CreateQuestionRequest) => {
      dispatch(createQuestionApiThunk(data));
    },
    [dispatch],
  );

  const updateQuestion = useCallback(
    async (data: UpdateQuestionRequest) => {
      dispatch(updateQuestionApiThunk(data));
    },
    [dispatch],
  );

  const searchQuestions = useCallback(
    async (data: SearchQuestionRequest) => {
      dispatch(searchQuestionApiThunk(data));
    },
    [dispatch],
  );

  const loadQuestionById = useCallback(
    async (data: GetQuestionRequest) => {
      dispatch(fetchQuestionByIdApiThunk(data));
    },
    [dispatch],
  );
  const clearQuestionAllApiStatus = useCallback(() => {
    dispatch(clearAllApiStatus());
  }, [dispatch]);
  const clearQuestion = useCallback(() => {
    dispatch(clearQuestionData());
  }, [dispatch]);
  const selectQuestion = useCallback(
    (data?: Question) => {
      dispatch(selectCurrentQuestion(data));
    },
    [dispatch],
  );

  return {
    currentSelectedQuestion,
    questionsList,
    getQuestionByIdApiStatus,
    loadQuestions,
    createQuestion,
    updateQuestion,
    searchQuestions,
    loadQuestionById,
    selectQuestion,
    clearQuestion,
    searchQuestionApiStatus,
    question,
    fetchQuestionsApiStatus,
    createQuestionApiStatus,
    updateQuestionApiStatus,
    clearQuestionAllApiStatus,
  };
};
